import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, SendIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
import { escaContacts, formatPhone } from '../../data/escaContacts';
import { track } from '../../utils/analytics';
export function EscaFooter() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const year = new Date().getFullYear();
  const sections = [{
    hash: 'expertise',
    label: c.nav.expertise
  }, {
    hash: 'research',
    label: c.nav.research
  }, {
    hash: 'cases',
    label: c.nav.cases
  }, {
    hash: 'about',
    label: c.nav.about
  }, {
    hash: 'faq',
    label: c.faq.title
  }];
  const go = (hash: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById(hash)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="bg-petrol text-sand" data-id="element-282" data-mp="27uj02qxsuvyg">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8 py-16 lg:py-20" data-id="element-283" data-mp="27vuavapnx3z2">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.1fr]" data-id="element-284" data-mp="23er9jszej0w">
          <div data-id="element-285" data-mp="64740n12b61x">
            <span className="font-display text-[1.75rem] font-bold tracking-[-0.04em]" data-id="element-286" data-mp="63pahy5sb5xp">
              ESCA
            </span>
            <p className="mt-4 text-[0.9375rem] text-petrol-100/60 leading-relaxed max-w-[30ch]" data-id="element-287" data-mp="b2ib4pzz32gg">
              {c.footer.tagline}
            </p>
            <div className="mt-6 flex items-center gap-3" data-id="element-288" data-mp="fvuwmr9cut4z">
              <a href={escaContacts.telegram} target="_blank" rel="noopener noreferrer" aria-label="Telegram" className="inline-flex items-center justify-center w-10 h-10 border border-petrol-600 text-petrol-100/70 hover:text-sand hover:border-sand transition-colors duration-200" data-id="element-289" data-mp="ksle9j0t5wsi">
                <SendIcon className="w-4 h-4" data-id="element-290" data-mp="2vlxwapao6om8" />
              </a>
              <a href={escaContacts.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="inline-flex items-center justify-center w-10 h-10 border border-petrol-600 text-petrol-100/70 hover:text-sand hover:border-sand transition-colors duration-200" data-id="element-291" data-mp="30k9atdbwtnas">
                <LinkedinIcon className="w-4 h-4" data-id="element-292" data-mp="gocne0wuf5g5" />
              </a>
            </div>
          </div>

          <nav aria-label="Footer sections" data-id="element-293" data-mp="btgukyjs8e1z">
            <p className="esca-eyebrow text-petrol-100/40" data-id="element-294" data-mp="qntoe515gv5s">
              {c.footer.navTitle}
            </p>
            <ul className="mt-5 space-y-3" data-id="element-295" data-mp="loh67xl84c9j">
              {sections.map(s => <li key={s.hash} data-id="element-296" data-mp="zh6r1yp0nb52">
                  <a href={`#${s.hash}`} onClick={go(s.hash)} className="text-[0.9375rem] text-petrol-100/70 hover:text-sand transition-colors duration-200" data-id="element-297" data-mp="zgf93qocdbx9">
                    {s.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="Services" data-id="element-298" data-mp="1o1a6lz1a4b38">
            <p className="esca-eyebrow text-petrol-100/40" data-id="element-299" data-mp="1o2ct7urkjrdc">
              {c.footer.legacyTitle}
            </p>
            <ul className="mt-5 space-y-3" data-id="element-300" data-mp="1t04uvgi0mruq">
              {c.footer.legacyLinks.map(l => <li key={l.to} data-id="element-301" data-mp="1e3dx1bnzpo78">
                  <Link to={l.to} className="text-[0.9375rem] text-petrol-100/70 hover:text-sand transition-colors duration-200" data-id="element-302" data-mp="1j2qk9xirwxac">
                    {l.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-303" data-mp="vdo1ungbf0es">
            <p className="esca-eyebrow text-petrol-100/40" data-id="element-304" data-mp="ve799a8ca6ek">
              {c.footer.contactTitle}
            </p>
            <ul className="mt-5 space-y-3" data-id="element-305" data-mp="10d0q9cmu4fjh">
              {escaContacts.phones.map(p => <li key={p} data-id="element-306" data-mp="mdr7q6b5p9cc">
                  <a href={`tel:${p}`} onClick={() => track('phone_click', {
                phone: p
              })} className="text-[0.9375rem] text-petrol-100/70 hover:text-sand transition-colors duration-200 tabular-nums" data-id="element-307" data-mp="mekhzh9bqgz8">
                    {formatPhone(p)}
                  </a>
                </li>)}
              <li data-id="element-308" data-mp="9jqpol407b0o">
                <a href={`mailto:${escaContacts.email}`} onClick={() => track('email_click')} className="text-[0.9375rem] text-petrol-100/70 hover:text-sand transition-colors duration-200" data-id="element-309" data-mp="9j8pjde80cnh">
                  {escaContacts.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-petrol-600 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" data-id="element-310" data-mp="3ms3lq2gl1rp6">
          <p className="text-[0.8125rem] text-petrol-100/45" data-id="element-311" data-mp="3huv3k1vfpnnx">
            © {year} ESCA. {c.footer.rights}
          </p>
          <p className="text-[0.8125rem] text-petrol-100/45" data-id="element-312" data-mp="1g1dmy8pbtch1">
            Executive Search · Worldwide
          </p>
        </div>
      </div>
    </footer>;
}